const AMOUNT = 'AMOUNT';
const PERCENTAGE = 'PERCENTAGE';

export default {
  AMOUNT,
  PERCENTAGE,
};
